







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class DomainDetailIframe extends Vue {
  private get remoteSrc() {
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + `/configuration/basic/domain-detail/${this.$route.params.domainNo}?serviceType=PREMIUM`;

    return src;
  }
}
